import { render } from "./NFTCard.vue?vue&type=template&id=b3897acc&scoped=true&ts=true"
import script from "./NFTCard.vue?vue&type=script&lang=ts"
export * from "./NFTCard.vue?vue&type=script&lang=ts"

import "./NFTCard.vue?vue&type=style&index=0&id=b3897acc&scoped=true&lang=css"

import exportComponent from "/vercel/path1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3897acc"]])

export default __exports__